import { useEffect } from "react";
import { useNavigate } from "react-router";

export type RedirectProps = {
  to: string;
  state?: Record<string, unknown>;
  replace?: boolean;
};

export const Redirect = ({ to, state, replace }: RedirectProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(to, { state, replace });
  }, [to, state, replace, navigate]);

  return null;
};
